import { Skeleton } from "@/app/components/shadcn/skeleton";

const PastSearchesSkeleton = () => {
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-16" />
      </div>
      <div className="space-y-0.5">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-8 sm:h-10 w-full rounded-md" />
        ))}
      </div>
    </div>
  );
};

export default PastSearchesSkeleton;